import React from 'react';

const IdentifyGeneralInfoPlaceholder = () => {
  return (
    <div>
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={`info-result${i}`}
          className="text__placeholder placeholder__bottom-space shimmer"
        />
      ))}
      <div className="text__placeholder--big placeholder__bottom-space shimmer" />
      <div className="text__placeholder--medium placeholder__bottom-space shimmer" />
      <div className="text__placeholder--small placeholder__bottom-space shimmer" />
    </div>
  );
};

export default IdentifyGeneralInfoPlaceholder;
